"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Validation = _interopRequireDefault(require("../Validation"));

var _InlineLoader = _interopRequireDefault(require("../InlineLoader"));

var _PageLoader = _interopRequireDefault(require("../PageLoader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var LoaderSize = '50px';

var Container = _styledComponents.default.div(_templateObject(), function (props) {
  return props.isLoading && "\n\t\tbackground-color: white;\n\t\ttext-align: center;\n\t\tdisplay: flex;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tmin-height: " + LoaderSize + ";\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t";
});

Container.displayName = 'Container';

var LoadingContainer = function LoadingContainer(_ref) {
  var loading = _ref.loading,
      error = _ref.error,
      fullPage = _ref.fullPage,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["loading", "error", "fullPage", "children"]);

  var Loader = fullPage ? _PageLoader.default : _InlineLoader.default;
  return _react.default.createElement(Container, _extends({
    isLoading: loading,
    error: error
  }, rest), loading && _react.default.createElement(Loader, {
    isLoading: true,
    secondary: true,
    size: LoaderSize
  }), error && _react.default.createElement(_Validation.default, {
    visible: true
  }, "An error has occurred, please try again."), !error && !loading && children);
};

LoadingContainer.displayName = 'LoadingContainer';
LoadingContainer.propTypes = {
  fullPage: _propTypes.bool,
  loading: _propTypes.bool.isRequired,
  error: _propTypes.bool,
  children: _propTypes.node
};
LoadingContainer.defaultProps = {
  error: false,
  fullPage: false,
  children: null
};
var _default = LoadingContainer;
exports.default = _default;